import { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    type?: string
    border?: string
    focus?: boolean
    disabled?: boolean
}

export const Wrapper = styled.div<Partial<InputProps>>`
    padding: 8px 12px;
    border: 1px solid #a1a1a1;
    border-radius: 8px;
    width: 100%;
    position: relative;
    ${(props) =>
        props.disabled
            ? 'background-color: lightgrey;'
            : props.focus && `border: 1.5px solid #2AB930;`};
`

export const FloatInput = styled.input<Partial<InputProps>>`
    outline: none;
    border-width: 0;
    background: transparent;
    width: 100%;
    height: 100%;
`

export const div = styled.div`
    position: absolute;
    color: black;
    &:hover {
        cursor: text;
    }
    transition: all 0.1s ease-in;
`
interface FloatProps {
    focus: boolean
    disabled?: boolean
}

export const FloatLabel = styled(div)<FloatProps>`
    color: ${(props) =>
        !props.disabled && props.focus ? '#1f8b24' : '#a1a1a1'};
    left: 10px;
    top: -10px;
    width: auto;
    font-size: 12px;
    background-color: ${(props) => (props.disabled ? 'lightgrey' : 'white')};
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 9px;
`
